<template>
    <div class="left-menu" >
		<!-- 切换菜单-->
		<div v-if="pathList.length==2&&distinguish(pathList)"  class="twoMenu">
			<el-aside style="height:calc(100vh - 80px)"  :width="width" >
				<div class="cut" style="margin-bottom: 10px">
					<span class="nape" :style="{'opacity':cutPathList!=pathList[inx]?'0.5':'1'}"  :key="inx" 
                     @click="cutPath(pathList[inx], 1)" v-for="(path,inx) in pathList">{{path.name}}
						<el-divider v-if="inx!=pathList.length-1" direction="vertical"></el-divider>
					</span>
				</div>
				<el-menu 
						:default-active="defaultMenu"
						@select="selectPage"
						class="el-menu-vertical-demo">
                            <el-menu-item v-for="(item,inx) in cutPathList.sourceTreeDTOList" :key="inx" :index="item.code">
                                <span slot="title">{{item.name}}</span>
                                <!--                    <i class="el-icon-menu" v-if="item.extend.resourceUrl==defaultMenu"></i>-->
                            </el-menu-item> 
				</el-menu>
			</el-aside>
		</div>
		<!--  单个或者组合菜单-->
        <div v-else class="moreMenus">
            <el-aside :width="width" style="height:calc(100vh - 80px)">
                <el-menu unique-opened :default-active="defaultMenu" class="el-menu-vertical-left"  @select="selectPage">
                    <div v-for="(item, index) in pathList" :key="index">
                        <template >   <!--v-if="item.selected"-->
                            <el-menu-item v-if="item.sourceTreeDTOList.length==0 " :index="item.code" style="font-size: 16px">
                                <span slot="title">{{item.name}}</span>
                                <i class="el-icon-menu" v-if="item.code==defaultMenu"></i>
                            </el-menu-item>
                            <el-submenu v-if="item.sourceTreeDTOList.length"  :key="item.code" :index="item.code">
                                <template slot="title">
                                    <span>{{item.name}}</span>
                                </template>
                                <el-menu-item-group v-for="(page, pageIndex) in item.sourceTreeDTOList" :key="pageIndex">
                                    <!--                                v-if="page.selected && page.resourceUrl && page.menuShow"-->
                                    <el-menu-item   :index="page.code" style="font-size: 14px">{{page.name}}</el-menu-item>
                                    <!--                                <i class="el-icon-menu" v-if="item.extend.resourceUrl==defaultMenu"></i>-->
                                </el-menu-item-group>
                            </el-submenu>
                        </template>

                    </div>
                </el-menu>
            </el-aside>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left-menu",
        props:['width'],
        data(){
            return{
                pathList:[],
                cutPathList:{},
                defaultMenu:'',
                clientHeight:'',
                isShow: true,
            }
        },
        computed: {
            headActiveIndex () {
                return this.$store.state.headActiveIndex
            },
            leftActiveIndex () {
                return this.$store.state.leftActiveIndex
            },
            menuList () {
                return this.$store.state.configMenuList
            },
        },
        watch: {
            headActiveIndex (newVal) {
                const result = this.menuList.filter(item => {
                    return item.code === newVal
                })
                if (result.length > 0) {
                    this.pathList = result[0].sourceTreeDTOList
                }
            },
            leftActiveIndex (newVal) {
                let path = newVal.split('/')[2]
                // this.cutPathList = []
                if (path === 'broadcast-announcement' || path === 'system-announcement') {
                    // this.cutPathList = this.pathList[0]
                    this.cutPath(this.pathList[0]);
                }
                if (path === 'xl-release') {
                    // this.cutPathList = this.pathList[1]
                    this.cutPath(this.pathList[1]);
                }
                // console.log('cutPathList', this.cutPathList)
                this.defaultMenu = newVal
            }
        },
        created() {
            this.clientHeight = (document.body.clientHeight - 80) +'px';
            // let path =this.$route.path.split('/')[1];
            // let configMenuList=this.$store.state.configMenuList;
            // if(sessionStorage.getItem('defaultMenu')){
            //     this.defaultMenu=sessionStorage.getItem('defaultMenu')
            //     configMenuList.forEach((item)=>{
            //         if(item.code=='/'+path){
            //             this.pathList=item.sourceTreeDTOList;
            //             if(this.pathList.length==2){
            //                 this.cutPath(this.pathList[0]);
            //             }
            //             this.$router.push(this.defaultMenu)
            //         }
            //     })
			// 	sessionStorage.removeItem('defaultMenu');
            // }else {
            //     configMenuList.forEach((item)=>{
            //         if(item.code=='/'+path){
            //             this.pathList=item.sourceTreeDTOList;
            //             if(this.pathList.length==2){
            //                 this.cutPath(this.pathList[0]);
            //             }
            //             this.defaultMenu=this.distinguishMenu(this.pathList)
            //         }
            //     })
            // }
            const result = this.menuList.filter(item => {
                return item.code === this.headActiveIndex
            })
            if (result.length !== 0) {
                this.pathList = result[0].sourceTreeDTOList
                // this.cutPathList = []
                if (this.distinguish(this.pathList)) {
                    this.cutPath(this.pathList[0]);
                    // this.cutPathList = this.pathList[0]
                }
            }
            // console.log('this.pathList', this.pathList)
            this.defaultMenu = this.$store.state.leftActiveIndex
        },
        methods:{
            distinguishMenu(item){ //判别菜单
                if(item[0].sourceTreeDTOList.length==0){
                    this.$router.push(item[0].code)
                    return item[0].code
                }else {
                    this.$router.push(item[0].sourceTreeDTOList[0].code);
                    return item[0].sourceTreeDTOList[0].code
                }
            },
            distinguish(item){ //判别菜单
                for(var i=0;i<item.length;i++){
                    if(item[i].sourceTreeDTOList.length==0){
                        return false
                    }
                }
                return true
            },
            cutPath(item, num){
                this.cutPathList = {}
                setTimeout(() => {
                    this.cutPathList=item;
                },50)
                if (num) {
                    let child = item.sourceTreeDTOList[0].code
                    this.$router.push(child)
                }
            },
            // 选择菜单
            selectPage(index) {
                if(this.$route.path != index) {
                    sessionStorage.setItem('defaultMenu',index)
                    this.$router.push(index)
                }
            },
        }
    }
</script>
<style   lang="less">
    @import "left-menu";
    .left-menu{
		width: 220px;
        height: calc(100vh - 120px);
        .el-menu-item.is-active {
            background:#0499e7 !important;
            color: #fff!important;
        }
        .el-submenu__title{
            font-weight: bolder;
            text-align: center !important;
        }
        .el-menu-item-group{
            .is-active{
                background:#0499e7 !important;
                color: #fff!important;
            }
            .el-menu-item-group__title{
                padding:0;
                padding-left: 20px !important;

            }
        }
        .el-menu-vertical-demo {
            .el-menu-item .is-active {
                background:#0499e7 !important;
                color: #fff!important;
            }
        }

        .el-menu-item:focus, .el-menu-item:hover {
            outline: 0;
            color: #fff;
            background:rgba(4, 153, 231, 0.7) !important;
        }
        .el-menu-item{
            height: 40px !important;
            line-height:40px!important;
            box-shadow: none;
            font-size: 12px !important;
            text-align: center !important;

        }
        .is-active{
            .el-submenu__title{
                span{
                    color: #0B70FE!important;
                }
            }
        }

    }

</style>